import React from 'react';

const RadioGroup = ({ label, name, options, value, onChange, className = '', required = false }) => (
  <div className={className}>
    <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-brand-muted">{label}</span>
    <div className="field-control rounded-xl px-3 py-2.5">
      <div className="flex flex-wrap gap-x-6 gap-y-3">
        {options.map((opt, index) => (
          <label key={opt} className="inline-flex cursor-pointer items-center gap-2 text-sm text-brand-ink">
            <input
              id={`${name}-${opt}`}
              className="h-4 w-4 accent-[var(--brand-deep)]"
              type="radio"
              name={name}
              value={opt}
              checked={value === opt}
              onChange={onChange}
              required={required && index === 0}
            />
            <span className="leading-none">
              {opt}
            </span>
          </label>
        ))}
      </div>
    </div>
  </div>
);

export default RadioGroup;